import { Component, Input, Output, EventEmitter, ViewChild } from '@angular/core';
import { TableFilterV2Component } from '../../../molecules/table-filterv2/ng/table-filterv2.component';
var TechnicalPropertyPopupComponent = /** @class */ (function () {
    function TechnicalPropertyPopupComponent() {
        this.filterChanges = new EventEmitter();
        this.onCloseClicked = new EventEmitter();
        this._currentRows = [];
    }
    TechnicalPropertyPopupComponent.prototype.ngOnChanges = function () {
        if (this.tableFilterV2Component) {
            this.tableFilterV2Component.refreshAllSliders();
        }
    };
    TechnicalPropertyPopupComponent.prototype.getClass = function (group) {
        var result = "";
        if (group.disabled) {
            result += " m-technical-property-popup__tab-nav--disabled";
        }
        else {
            if (group.checked) {
                result += " m-technical-property-popup__tab-nav--checked";
            }
            if (group.active) {
                result += " m-technical-property-popup__tab-nav--active";
            }
        }
        return result;
    };
    Object.defineProperty(TechnicalPropertyPopupComponent.prototype, "currentGroup", {
        /**
         * get current group
         * if no active group, get the 1st group as default selected one
         */
        get: function () {
            this._currentGroup = this.filterGroups.find(function (item) { return item.active === true; });
            if (!this._currentGroup) {
                this._currentGroup = this.filterGroups[0];
            }
            return this._currentGroup;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TechnicalPropertyPopupComponent.prototype, "currentRows", {
        /*
        //filterRows: all facet rows
        //filterGroup: the selected filterGroup, with facet code and group mapping relation
        //return currentRows, the mapping facet rows, in selected group
        */
        get: function () {
            this.getCurrentRows();
            return this._currentRows;
        },
        enumerable: true,
        configurable: true
    });
    TechnicalPropertyPopupComponent.prototype.getCurrentRows = function () {
        var _this = this;
        this._currentRows = [];
        if (this.currentGroup) {
            this._currentGroup.values.forEach(function (code) {
                var _a;
                var rows = _this.filterRows.filter(function (f) { return f.code === code && f.isHidden === false; });
                if (rows && rows.length > 0) {
                    (_a = _this._currentRows).push.apply(_a, rows);
                }
            });
        }
    };
    TechnicalPropertyPopupComponent.prototype.onFilterChange = function () {
        this.filterChanges.emit();
    };
    TechnicalPropertyPopupComponent.prototype.onShowResultClicked = function () {
        this.onClickClose();
    };
    TechnicalPropertyPopupComponent.prototype.onMaterialFilterChange = function () {
        this.filterChanges.emit();
    };
    TechnicalPropertyPopupComponent.prototype.closeFilterSection = function () {
    };
    TechnicalPropertyPopupComponent.prototype.onClickClose = function () {
        this.showFilterPopup = false;
        this.onCloseClicked.emit();
    };
    TechnicalPropertyPopupComponent.prototype.onGroupClick = function (event, group) {
        event.preventDefault();
        event.stopPropagation();
        this.filterGroups.forEach(function (g) { return g.active = false; });
        group.active = true;
        this._currentGroup = group;
    };
    TechnicalPropertyPopupComponent.prototype.resetAllFilters = function () {
        this.tableFilterV2Component.onResetAllClicked();
    };
    TechnicalPropertyPopupComponent.prototype.refreshSliderRow = function (filter) {
        this.tableFilterV2Component.refreshSliderRow(filter);
    };
    TechnicalPropertyPopupComponent.decorators = [
        { type: Component, args: [{
                    selector: 'cov-technical-property-popup',
                    template: "<div class=\"m-technical-property-popup\" \r\n     [ngClass]=\"{'state-m-technical-property-popup--shown' : showFilterPopup}\"\r\n     data-t-name=\"TechnicalPropertyPopup\" \r\n     data-t-id=\"56\">\r\n     <div class=\"m-technical-property-popup__loading-wrapper\"\r\n          [ngClass]=\"{'state-loading-wrapper--shown': searchLoading}\">\r\n        <cov-loading-indicator ></cov-loading-indicator>\r\n    </div>\r\n    <div class=\"m-technical-property-popup__header\">\r\n        <a class=\"m-technical-property-popup__closer js-property-popup-closer\" \r\n           (click)=\"onClickClose()\"></a>\r\n        <h1 class=\"a-heading a-heading--style2 m-technical-property-popup__header-title\" \r\n            [innerHtml]=\"filterHeading\"></h1>\r\n        <div class=\"m-technical-property-popup__header-select\">\r\n            <cov-filter-two-level-multiselect *ngIf=\"materialAttributeFilter\"\r\n                [filterBackLinkText]=\"filterBackLinkText\"\r\n                [filter]=\"materialAttributeFilter\"\r\n                [triggerChangeWhenSelect]=\"true\"\r\n                (filterChanges)=\"onMaterialFilterChange()\"\r\n                (filterSectionCloses)=\"closeFilterSection()\">\r\n            </cov-filter-two-level-multiselect>\r\n        </div>\r\n        <button class=\"m-technical-property-popup__back-button js-property-popup-closer\"\r\n                (click)=\"onClickClose()\">\r\n            <span class=\"m-technical-property-popup__back-button--txt\">{{filterBackLinkText}}</span>\r\n        </button>\r\n    </div>\r\n    <div class=\"m-technical-property-popup__body\">\r\n        <ul class=\"m-technical-property-popup__tab-navs\" *ngIf=\"filterGroups && filterGroups.length > 0\">\r\n            <ng-template ngFor let-group [ngForOf]=\"filterGroups\">\r\n                <li class=\"m-technical-property-popup__tab-nav js-m-technical-property-popup__tab-nav \"\r\n                    [ngClass]=\"getClass(group)\"\r\n                    (click)=\"onGroupClick($event, group)\">\r\n                    <span class=\"m-technical-property-popup__tab-nav--txt\"\r\n                          [innerHtml]=\"group.name\"></span>\r\n                    <span class=\"m-technical-property-popup__tab-nav--icon\"></span>\r\n                </li>\r\n            </ng-template>\r\n        </ul>\r\n\r\n        <div class=\"m-technical-property-popup__tab-content\" *ngIf=\"currentGroup\">\r\n            <cov-table-filterv2\r\n                #tableFilterV2Component\r\n                [filterRows]=\"filterRows\"\r\n                [currentGroup]=\"currentGroup\"\r\n                [currentRows]=\"currentRows\"\r\n                [searchText]=\"searchButtonText\"\r\n                [labelPropertyName]=\"labelPropertyName\"\r\n                [labelTestCondition]=\"labelTestCondition\"\r\n                [labelPossibleValues]=\"labelPossibleValues\"\r\n                [labelResetAllButton]=\"labelResetAllButton\"\r\n                [labelShowResultButton]=\"labelShowResultButton\"\r\n                [labelUnit]=\"labelUnit\"\r\n                [labelReset]=\"labelReset\"\r\n                [productCountText]=\"productCountText\"\r\n                [totalCount]=\"totalCount\"\r\n                [disabledCondition]=\"disabledCondition\"\r\n                [activeFilterCondition]=\"activeFilterCondition\"\r\n                [noFilterResultMessage]=\"propertyNoFilterResultMessage\"\r\n                (filterChanges)=\"onFilterChange()\"\r\n                (showResultClicked)=\"onShowResultClicked()\">\r\n            </cov-table-filterv2>\r\n        </div>\r\n    </div>\r\n</div>"
                }] }
    ];
    TechnicalPropertyPopupComponent.propDecorators = {
        filterHeading: [{ type: Input }],
        materialAttributeFilter: [{ type: Input }],
        filterGroups: [{ type: Input }],
        filterRows: [{ type: Input }],
        showFilterPopup: [{ type: Input }],
        searchButtonText: [{ type: Input }],
        productCountText: [{ type: Input }],
        totalCount: [{ type: Input }],
        labelPropertyName: [{ type: Input }],
        labelTestCondition: [{ type: Input }],
        labelPossibleValues: [{ type: Input }],
        propertyNoFilterResultMessage: [{ type: Input }],
        searchLoading: [{ type: Input }],
        labelUnit: [{ type: Input }],
        labelReset: [{ type: Input }],
        filterBackLinkText: [{ type: Input }],
        labelResetAllButton: [{ type: Input }],
        labelShowResultButton: [{ type: Input }],
        disabledCondition: [{ type: Input }],
        activeFilterCondition: [{ type: Input }],
        tableFilterV2Component: [{ type: ViewChild, args: ['tableFilterV2Component',] }],
        filterChanges: [{ type: Output }],
        onCloseClicked: [{ type: Output }]
    };
    return TechnicalPropertyPopupComponent;
}());
export { TechnicalPropertyPopupComponent };
//# sourceMappingURL=technical-property-popup.component.js.map